import * as yup from 'yup'
import { unformatNumberBR } from 'src/utils'

const requiredField = 'Campo obrigatório!'

export const schema = yup.object().shape({
  weight: yup
    .number()
    .transform((curr, orig) => unformatNumberBR(orig))
    .min(0, 'Pesagem deve ser maior do que 0!')
    .notOneOf([0], 'Pesagem não deve ser 0!')
    .required(requiredField),
  tipoAvarias: yup.string().required(requiredField),
  quantidadeAvarias: yup
    .number()
    .transform((_, orig) => unformatNumberBR(orig))
    .required(requiredField)
    .min(0, 'Pesagem deve ser no mínimo 0')
    .when('tipoAvarias', (tipoAvarias, actualSchema) => {
      if (!tipoAvarias) {
        return actualSchema
      }

      if (['', 'NENHUM'].includes(tipoAvarias)) {
        return actualSchema.oneOf([0], 'Valor deve ser 0!')
      }
      return actualSchema.notOneOf([0], 'Valor não deve ser 0!')
      .max(yup.ref('weight'), 'A quantidade deve ser menor ou igual ao total')
    }),
})
